import SV from 'server-vars';
import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'dibs-react-intl';
import { ReactRelayContext } from 'react-relay';
import { type Locale } from 'dibs-intl/exports/locales';
import { isAnyModalOpen } from 'dibs-elements/exports/ModalContainer';
import { LanguageDiscrepancyModal } from './LanguageDiscrepancyModal';
import getRelayEnvironment from '../relayClientEnvironment';

import { type Options } from '../notificationQueue/types';

const locale = SV.get('locale');
const isMobile = SV.get('settings.isMobile');

export default function load(options: Options, userPreferredLocale: Locale): void {
    setTimeout(() => {
        const div = document.createElement('div');
        document.body.appendChild(div);
        const root = createRoot(div, { identifierPrefix: 'language-discrepancy-modal' });

        if (isAnyModalOpen()) {
            return;
        }

        root.render(
            <IntlProvider locale={locale}>
                <ReactRelayContext.Provider
                    value={{ environment: options?.environment || getRelayEnvironment() }}
                >
                    <LanguageDiscrepancyModal
                        isModalOpen
                        locale={userPreferredLocale}
                        isMobile={isMobile}
                        runNextNotification={options?.runNextNotification}
                    />
                </ReactRelayContext.Provider>
            </IntlProvider>
        );
    }, 2000);
}
